import { Fragment, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import './MainHeader.css';
import logo from "../images/logo2.png";


const MainHeader = () => {

    const _openSideMenu = () => {
        const sidebar = document.getElementById('sidebar');
        const menuOverlay = document.getElementById('menu-overlay');
        sidebar.classList.toggle('active');
        menuOverlay.classList.toggle('active');
    }

    const _closeSideMenu = () => {
        const sidebar = document.getElementById('sidebar');
        const menuOverlay = document.getElementById('menu-overlay');
        sidebar.classList.remove('active');
        menuOverlay.classList.remove('active');
    }

    const navigationLinks = useMemo( () => {
        return (
            <Fragment>
                <ul className={ 'menu' }>
                    <li><NavLink activeClassName={ 'active' } exact to="/" onClick={ _closeSideMenu }>HOME</NavLink></li>
                    <li><NavLink activeClassName={ 'active' } to="/about-us" onClick={ _closeSideMenu }>ABOUT</NavLink></li>
                    <li><NavLink activeClassName={ 'active' } to="/products" onClick={ _closeSideMenu }>PRODUCTS</NavLink></li>
                    <li><NavLink activeClassName={ 'active' } to="/contact-us" onClick={ _closeSideMenu }>CONTACT</NavLink></li>
                </ul>
            </Fragment>
        );
    }, [] );

    return (
        <header className={ 'header' }>
            <img src={ logo } alt="avatar" />
            <nav>
                <div className={ 'sideMenuButton' } onClick={ _openSideMenu } >{ '☰' }</div>
                <div id={ 'sidebar' } className={ 'sidebar' }> { navigationLinks }</div>
                <div id={ 'menu-overlay' } className={ 'menu-overlay' } onClick={ _closeSideMenu }></div>
                { navigationLinks }
            </nav>
        </header>
    );
};
export default MainHeader;
